<script lang="ts">
    import { Pagination, PaginationItem, PaginationLink,Col} from "sveltestrap";
    import { href, Next, Previous } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
</script>
<Col xl="12">
    <Card headerTitle="Pagination With Active And Disabled" cardHeaderprops="pb-0">
      <div slot="contentbody">
        <Pagination aria-label="...">
          <ul class="pagination pagination-primary">
            <PaginationItem disabled>
              <PaginationLink>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem active>
              <PaginationLink {href}>
                {'2'}
                <span class="sr-only">{'(current)'}</span>
              </PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{Next}</PaginationLink>
            </PaginationItem>
          </ul>
        </Pagination>
      </div>
    </Card>
</Col>
